import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { store } from './store'
// import * as firebase from 'firebase'

require('./assets/css/materialdesignicons.min.css')

Vue.use(Vuetify)

let opts = {
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#1e2d4f',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      }
    }
  }
}

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  vuetify: new Vuetify(opts),
  el: '#app',
  router,
  store,
  render: h => h(App),
  created () {
    let company = localStorage.getItem('company') !== null && localStorage.getItem('company') !== undefined ? localStorage.company : null
    this.$store.dispatch('checkCompany', company)
    let url = localStorage.getItem('remoteServer') !== null && localStorage.getItem('remoteServer') !== undefined ? localStorage.remoteServer : 'https://cwelite.aquariusit.com'
    this.$store.dispatch('setURL', url)
    // window.addEventListener('visibilitychange', function () {
    //   if (!document.hidden) {
    //     window.location.reload()
    //   }
    // })
    // firebase.database().ref('appData/versions').once('value')
    //   .then(result => {
    //     const latestVersions = result.val()
    //     if (localStorage.getItem('db-version')) {
    //       const currentDbVersion = localStorage.getItem('db-version')
    //       if (latestVersions.db !== currentDbVersion) {
    //         console.log('Database outdated, clearing local storage')
    //         localStorage.removeItem('languages')
    //         localStorage.removeItem('disclaimerText')
    //         localStorage.setItem('db-version', latestVersions.db)
    //       }
    //     }
    //     if (latestVersions.app !== this.appVersion) {
    //       console.log('App outdated, need to update')
    //       this.$store.dispatch('appOutdated', true)
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error)
    //   })
  },
  data () {
    return {
      appVersion: '0.8.11'
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js